<template>
  <div class="order-list">
    <div class="order-list-header">
      <div class="order-desc">
        <span>{{ order.createTime | dateformat('YYYY-MM-DD HH:mm:ss') }}</span>
        <span>订单号：{{ order.id }}</span>
        <span>送货单位：{{ order.shopName }}</span>
        <span>订单金额：￥{{ order.total }}</span>
        <span>{{ payType }}</span>
        <span>订单状态：{{ status }}</span>
      </div>
      <div class="order-operate">
        <div class="operate-btn">
          <b-button v-if="pay" class="action-btn" @click="payOrder(order.payType)">支付</b-button>
          <b-button v-if="cancel" class="action-btn cancel-order" @click="cancelOrder">取消</b-button>
        </div>
        <span class="on-and-down" :class="{'is-show':!order.show}" @click="disShow" />
      </div>
    </div>
    <div v-if="order.show" class="order-items">
      <div v-for="(item,index) in order.items" :key="index">
        <order-item :item="item" />
      </div>

    </div>
  </div>
</template>
<script>
import OrderItem from './OrderItem'
export default {
  components: {
    'order-item': OrderItem
  },
  props: {
    order: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      orderStatus: {
        0: '待支付',
        1: '待接单',
        2: '已完成',
        3: '已取消',
        4: '配送中',
        5: '部分配送'
      }
    }
  },
  computed: {
    pay: function () {
      let result = false
      if (this.order.status === 0) {
        result = true
      }
      return result
    },
    cancel: function () {
      let result = false
      if (this.order.status === 1 || this.order.status === 0) { result = true }
      return result
    },
    payType: function () {
      let result = '货到付款'
      if (this.order.payType === 2) {
        result = '微信'
      }
      if (this.order.payType === 4) {
        result = '支付宝'
      }
      return result
    },
    status: function () {
      const num = this.order.status
      const result = this.orderStatus[num] || '部分配送'
      return result
    }
  },
  created () {

  },
  mounted () {
  },
  methods: {
    payOrder (type) {
      const path = '/hy-sb-order/purchaseOrder/multiplePay'
      this.$axios.post(path, { ids: [this.order.id] }).then(response => {
        const { content: { url }, code } = response
        if (code === '0') {
          if (type === 2) {
            this.$emit('showModal', url)
          } else {
            window.location.href = url
          }
        } else {
          this.$bvToast.toast('支付失败', {
            autoHideDelay: 2000
          })
          return
        }
      })
    },
    cancelOrder () {
      const url = '/hy-sb-order/purchaseOrder/cancelOrder'
      this.$axios.post(url, { orderId: this.order.id }).then(response => {
        const { code } = response
        if (code === '0') {
          this.order.status = 3
          console.log(response, '取消订单成功')
        } else {
          this.$bvToast.toast('取消订单失败', {
            autoHideDelay: 2000
          })
          return
        }
      })
    },
    disShow () {
      this.order.show = !this.order.show
    }
  }
}
</script>
<style>
  .order-list-header {
    background-color: #e3e4e5;
    display: flex;
    height: 30px;
    line-height: 30px;
  }
  .order-list-header span {
    margin-right: 1.125rem;
  }
  .order-list-header span:last-child {
    margin-right: 0;
  }
  .order-list-header .order-desc {
    flex: 87.7%;
    text-align: left;
    font-size: 1rem;
    text-indent: 0.675rem;
  }
  .order-list-header .order-operate {
    flex: 12.3%;
    vertical-align: middle;
    text-align: right;
    position: relative;
  }
  .order-operate .btn-secondary:hover {
    color: #00a4e9;
    background-color: #fff;
    border-color: #00a4e9;
  }
  .order-operate .btn:active,
  .order-operate .btn-secondary.active {
  outline: 0;
  box-shadow: 0 0 0 0;
}
  .order-list-header .on-and-down {
    position: absolute;
    right: 8px;
    top: 5px;
    display: inline-block;
    width: 20px;
    height: 20px;
    background-color: #fff;
    border: 1px solid #ccc;
    vertical-align: middle;
    transition: all .3s;
  }
  .order-list-header .on-and-down::after {
    cursor: pointer;
    position: absolute;
    top: 5px;
    left: 3px;
    display: block;
    color: #000;
    content: '';
    border-top: 0.7em solid;
    border-right: 0.4em solid transparent;
    border-left: 0.4em solid transparent;
  }
  .order-list-header .is-show::after {
    transform: rotateZ(180deg);
    transform-origin:center center
  }
  .operate-btn {
    position: absolute;
    right: 26px;
  }
  .action-btn {
    background-color: #fff;
    height: 25px;
    width: 50px;
    border: 1px solid #00a4e9;
    color: #00a4e9;
    padding: 0;
    margin-right: 8px;
    font-size: 0.875rem;
  }
  .order-list .order-items > div:last-child {
    padding-bottom: 10px;
  }
</style>
